<template>
    <div class="flex items-center justify-between mb-6 px-2">
        <div
            v-for="(step, index) in steps"
            :key="step.key"
            class="flex items-center"
            :class="{ 'flex-1': index < steps.length - 1 }"
        >
            <div class="flex items-center gap-2">
                <div
                    class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold shrink-0"
                    :class="index <= activeStep
                        ? 'bg-primary text-white'
                        : 'bg-gray-200 text-gray-500'"
                >
                    {{ index + 1 }}
                </div>
                <span
                    class="text-sm font-medium whitespace-nowrap"
                    :class="index <= activeStep ? 'text-primary' : 'text-gray-400'"
                >
                    {{ step.label }}
                </span>
            </div>
            <div
                v-if="index < steps.length - 1"
                class="flex-1 h-px mx-3"
                :class="index < activeStep ? 'bg-primary' : 'bg-gray-200'"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import i18n from '@/i18n'
import { computed } from 'vue'

defineProps<{
    activeStep: number
}>()

const steps = computed(() => [
    {
        key: 'start',
        label: i18n.t('widget.aiInstructions.step.start')
    },
    {
        key: 'template',
        label: i18n.t('widget.aiInstructions.step.template')
    },
    {
        key: 'customize',
        label: i18n.t('widget.aiInstructions.step.customize')
    }
])
</script>
